import React, { useEffect, useState } from 'react'
import styles from "./Loginnew.module.css";
import { login_Api, signup_Api, verifycode } from '../dashboardapi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';

const Loginnew = () => {
    const [active, setActive] = useState(false)
    const [showsignInpassword, setShowSignInPassword] = useState(false)
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    // const [state, setState] = useState("signIn")
    const [signInDetails, setSignInDetails] = useState({ email: "", password: "" });
    const [signUpDetails, setSignUpDetails] = useState({ email: "", password: "", confirmpassword: "" })
    const [code, setCode] = useState("");

    const { loginpages, action } = useParams();
    const navigate = useNavigate();
    const toast = useToast();

    useEffect(() => {
        if (loginpages === "signUp") {
            setActive(true);
            setSignUpDetails({ email: "", password: "", confirmpassword: "" })
        } else {
            setActive(false)
            setSignUpDetails({ email: "", password: "", confirmpassword: "" })
        }
    }, [loginpages])

    // useEffect(() => {
    //     refreshpage()
    // }, [])

    const handlesignInDetails = (e) => {
        const { name, value } = e.target
        setSignInDetails({
            ...signInDetails,
            [name]: value
        })
    }

    const getRedirectPath = () => {
        let params = window.location.search.replace("?", "").split("&")
        for (let param of params) {
            let keyPair = param.split("=")
            if (keyPair.length === 2 && keyPair[0] === "redirect") {
                return keyPair[1];
            }
        }
        return "/dashboard/myprojects";
    }
    // getRedirectPath()

    const handleSignIn = async (e) => {
        e.preventDefault();
        let result = await login_Api(signInDetails.email, signInDetails.password)
        if (result.data) {
            toast({
                title: "SignIn Successful",
                description: "You have successfully signed In",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            localStorage.setItem("token", result.data.token);
            setSignInDetails({ email: "", password: "" })
            let redirect = getRedirectPath()
            navigate(redirect)
        } else {
            if (result.error) {
                // console.log(result.error.detail);
                toast({
                    title: "signIn failed",
                    description: result.error.detail,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        }
    }
    //MARK:handle SignUP
    const handleSignUp = async (e) => {
        e.preventDefault();
        try {
            let result = await signup_Api(loginpages, signUpDetails.email, signUpDetails.password, signUpDetails.confirmpassword);
            if (result.data) {
                if (result.data.status === "email") {
                    toast({
                        title: "Verification Code sent to your email",
                        description: result.data.message,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                    if (loginpages === "signIn") {
                        navigate("/loginnew/signIn/verifyCode")
                    } else {
                        navigate("/loginnew/signUp/verifyCode")
                    }
                }
                if (result.data.status === "complete") {
                    toast({
                        title: "",
                        description: result.data.message,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                    navigate("/loginnew/signIn")
                }
            } else {
                let error = result.error.message
                toast({
                    title: "signUp failed",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "signUp failed",
                description: "Failed to signUp please try again",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const verifycodeapi = async (e) => {
        e.preventDefault();
        let result = await verifycode(loginpages, signUpDetails.email, code)
        if (result.data) {
            // console.log(result.data);
            toast({
                title: "Code verified successfully",
                status: "success",
                duration: 2000,
                isClosable: true,
            })
            navigate(`/loginnew/${loginpages}/confirmPassword`)
        } else {
            let error = result.error.message
            toast({
                title: 'Verification unsuccessfull',
                description: error,
                status: 'error',
                duration: 2000,
                isClosable: "true"
            })

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setSignUpDetails({ ...signUpDetails, [name]: value })
    }

    // const refreshpage = () => {
    //     navigate("/loginnew/signIn")
    // }

    // const renderScreen = () => {
    //     switch (loginpages) {
    //         case "signIn":
    //             return (
    //                 <form className={styles.form} onSubmit={handleSignIn}>
    //                     <div className={styles.signindiv1}>
    //                         <div className={styles.signinheadouter}>
    //                             <h1 className={styles.signinheading}>Sign In</h1>
    //                         </div>
    //                         <div className={styles.signdiv2}>
    //                             <label>E-mail ID</label>
    //                             <input onChange={handlesignInDetails} type='email' placeholder="Email" value={signInDetails.email} name='email' required />
    //                             <label>Password</label>
    //                             <div className={styles.passwordfield}>
    //                                 <input type={`${showPassword ? "text" : "password"}`} placeholder="Password" name='password' value={signInDetails.password} onChange={handlesignInDetails} required />
    //                                 <img onClick={() => setShowPassword(!showPassword)} className={styles.passwordeye} src={showPassword ? process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeopen.png" : process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeclose.png"} alt='show_password' />
    //                             </div>
    //                         </div>
    //                         <Link to={"/loginnew/forgetpassword"} className={styles.forget}>Forgot your password?</Link>
    //                         <button type='submit' className={styles.ghost}>Sign In</button>
    //                     </div>
    //                 </form>
    //             )
    //         case "forgetpassword":
    //             return (
    //                 <form className={styles.form} onSubmit={handleSignIn}>
    //                     <div className={styles.signindiv1}>
    //                         <div className={`${styles.forgetdiv}`}>
    //                             <h1 className={styles.signinheading}>Forget Password?</h1>
    //                             <p>Enter your E-mail address and we will send a code to reset your password.</p>
    //                         </div>
    //                         <div className={styles.signdiv2}>
    //                             <label>E-mail ID</label>
    //                             <input type='email' placeholder="Email" required />
    //                         </div>
    //                         <Link to={"/loginnew/signIn"} className={styles.forget} >Back to SignIn</Link>
    //                         <Link to={"/loginnew/verifyCode"} className={styles.ghost}>Sent Code</Link>
    //                     </div>
    //                 </form>
    //             )
    //         case "verifyCode":
    //             return (
    //                 <form className={styles.form} action="#">
    //                     <div className={styles.signindiv1}>
    //                         <div className={`${styles.forgetdiv}`}>
    //                             <h1 className={styles.signinheading}>Enter the verification code</h1>
    //                             <p>sent to your mail ID</p>
    //                         </div>
    //                         <div className={styles.signdiv2}>
    //                             <label></label>
    //                             <input type='number' placeholder="Enter your code" required />
    //                         </div>
    //                         {/* <button className={styles.forget} onClick={() => setForget(false)}>Back to SignIn</button> */}
    //                         <Link to={"/loginnew/confirmPassword"} className={styles.ghost}>Verify</Link>
    //                     </div>
    //                 </form>
    //             )
    //         case "confirmPassword":
    //             return (
    //                 <form className={styles.form} action="#">
    //                     <div className={styles.signindiv1}>
    //                         <div className={`${styles.forgetdiv}`}>
    //                             <h1 className={styles.signinheading}>Create New Password</h1>
    //                         </div>
    //                         <div className={styles.signdiv2}>
    //                             <label>New Password</label>
    //                             <div className={styles.passwordfield}>
    //                                 <input type={`${showPassword ? "text" : "password"}`} placeholder="Password" required />
    //                                 <img onClick={() => setShowPassword(!showPassword)} className={styles.passwordeye} src={showPassword ? process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeopen.png" : process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeclose.png"} alt='show_password' />
    //                             </div>
    //                             <label>Confirm New Password</label>
    //                             <div className={styles.passwordfield}>
    //                                 <input type={`${showConfirmPassword ? "text" : "password"}`} placeholder="Confirm Password" required />
    //                                 <img onClick={() => setShowConfirmPassword(!showConfirmPassword)} className={styles.passwordeye} src={showConfirmPassword ? process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeopen.png" : process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeclose.png"} alt='show_password' />
    //                             </div>
    //                         </div>
    //                         <Link className={styles.ghost}>Submit</Link>
    //                     </div>
    //                 </form>
    //             )
    //         case "signUp":
    //             return (
    //                 <form className={styles.form} onSubmit={handleSignUp}>
    //                     <div className={styles.signindiv1}>
    //                         <div className={styles.signinheadouter}>
    //                             <h1 className={styles.signinheading}>Sign Up</h1>
    //                         </div>
    //                         <div className={styles.signdiv2}>
    //                             <label>E-mail ID</label>
    //                             <input name='email' type="email" placeholder="Email" value={signUpDetails.email} onChange={handleChange} required />
    //                             {/* <label>Password</label>
    //                             <div className={styles.passwordfield}>
    //                                 <input name='password' value={signUpDetails.password} type={`${showPassword ? "text" : "password"}`} placeholder="Password" onChange={handleChange} required />
    //                                 <img onClick={() => setShowPassword(!showPassword)} className={styles.passwordeye} src={showPassword ? process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeopen.png" : process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeclose.png"} alt='show_password' />
    //                             </div>
    //                             <label>Confirm Password</label>
    //                             <div className={styles.passwordfield}>
    //                                 <input name='confirmpassword' value={signUpDetails.confirmpassword} type={`${showConfirmPassword ? "text" : "password"}`} placeholder="Confirm Password" onChange={handleChange} required />
    //                                 <img onClick={() => setShowConfirmPassword(!showConfirmPassword)} className={styles.passwordeye} src={showConfirmPassword ? process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeopen.png" : process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeclose.png"} alt='show_password' />
    //                             </div> */}
    //                         </div>

    //                         {/* <button type='submit' className={styles.ghost}>Sign Up</button> */}
    //                         <Link to={"/loginnew/signUp/verifyCode"} className={styles.ghost}>Sent Code</Link>

    //                     </div>
    //                 </form>
    //             )

    //         default:
    //             return null;
    //     }
    // }
    // signIn
    //      forgetPassword
    // signUp
    //      
    //

    // console.log(signUpDetails);


    //MARK:Render Screen
    const renderScreen = () => {
        // forgetpassword, verifyCode and confirmPassword common for both signIn and signUp functionalities
        if (action?.toLowerCase() === "forgetpassword") {
            return (
                <form className={styles.form} onSubmit={handleSignUp}>
                    <div className={styles.signindiv1}>
                        <div className={`${styles.forgetdiv}`}>
                            <h1 className={styles.signinheading}>Forget Password?</h1>
                            <p>Enter your E-mail address and we will send a code to reset your password.</p>
                        </div>
                        <div className={styles.signdiv2}>
                            <label>E-mail ID</label>
                            <input name='email' type="email" placeholder="Email" value={signUpDetails.email} onChange={handleChange} required />
                        </div>
                        <Link to={"/loginnew/signIn"} className={styles.forget} >Back to SignIn</Link>
                        <button type='submit' className={styles.ghost}>Sent Code</button>
                    </div>
                </form>
            )
        }
        if (action?.toLowerCase() === "verifycode") {
            return (
                <form className={styles.form} onSubmit={verifycodeapi}>
                    <div className={styles.signindiv1}>
                        <div className={`${styles.forgetdiv}`}>
                            <h1 className={styles.signinheading}>Enter the verification code</h1>
                            <p>sent to your mail ID</p>
                        </div>
                        <div className={styles.signdiv2}>
                            <label></label>
                            <input type='number' placeholder="Enter your code" onChange={(e) => setCode(e.target.value)} required />
                        </div>
                        {/* <button className={styles.forget} onClick={() => setForget(false)}>Back to SignIn</button> */}
                        <button type='submit' className={styles.ghost}>Verify</button>
                    </div>
                </form>
            )
        }
        if (action?.toLowerCase() === "confirmpassword") {
            return (
                <form className={styles.form} onSubmit={handleSignUp}>
                    <div className={styles.signindiv1}>
                        <div className={`${styles.forgetdiv}`}>
                            <h1 className={styles.signinheading}>Create New Password</h1>
                        </div>
                        <div className={styles.signdiv2}>
                            <label>New Password</label>
                            <div className={styles.passwordfield}>
                                <input type={`${showPassword ? "text" : "password"}`} placeholder="Password" required name='password' value={signUpDetails.password} onChange={handleChange} />
                                <img onClick={() => setShowPassword(!showPassword)} className={styles.passwordeye} src={showPassword ? process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeopen.png" : process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeclose.png"} alt='show_password' />
                            </div>
                            <label>Confirm New Password</label>
                            <div className={styles.passwordfield}>
                                <input type={`${showConfirmPassword ? "text" : "password"}`} placeholder="Confirm Password" required name='confirmpassword' value={signUpDetails.confirmpassword} onChange={handleChange} />
                                <img onClick={() => setShowConfirmPassword(!showConfirmPassword)} className={styles.passwordeye} src={showConfirmPassword ? process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeopen.png" : process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeclose.png"} alt='show_password' />
                            </div>
                        </div>
                        <button type='submit' className={styles.ghost}>Submit</button>
                    </div>
                </form>
            )
        }

        if (loginpages.toLowerCase() === "signin") {
            return (
                <form className={styles.form} onSubmit={handleSignIn}>
                    <div className={styles.signindiv1}>
                        <div className={styles.signinheadouter}>
                            <h1 className={styles.signinheading}>Sign In</h1>
                        </div>
                        <div className={styles.signdiv2}>
                            <label>E-mail ID</label>
                            <input onChange={handlesignInDetails} type='email' placeholder="Email" value={signInDetails.email} name='email' required />
                            <label>Password</label>
                            <div className={styles.passwordfield}>
                                <input type={`${showsignInpassword ? "text" : "password"}`} placeholder="Password" name='password' value={signInDetails.password} onChange={handlesignInDetails} required />
                                <img onClick={() => setShowSignInPassword(!showsignInpassword)} className={styles.passwordeye} src={showsignInpassword ? process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeopen.png" : process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/eyeclose.png"} alt='show_password' />
                            </div>
                        </div>
                        <Link to={"/loginnew/signIn/forgetpassword"} className={styles.forget}>Forgot your password?</Link>
                        <button type='submit' className={styles.ghost}>Sign In</button>
                    </div>
                </form>
            )
        }
        if (loginpages.toLowerCase() === "signup")
            return (
                <form className={styles.form} onSubmit={handleSignUp}>
                    <div className={styles.signindiv1}>
                        <div className={styles.signinheadouter}>
                            <h1 className={styles.signinheading}>Sign Up</h1>
                        </div>
                        <div className={styles.signdiv2}>
                            <label>E-mail ID</label>
                            <input name='email' type="email" placeholder="Email" value={signUpDetails.email} onChange={handleChange} required />
                        </div>
                        
                        <div className={styles.privacy_policy}>
                            <input id='privacy_pol' style={{marginRight: "3px"}} type="checkbox" required />

                            <label for="privacy_pol" className={styles.privacy_label}>I have read and accepted the 
                                <Link to={""}  className={styles.privacy_label_link}> Terms of Use </Link>
                                and
                                <Link to={""} className={styles.privacy_label_link}> Privacy Policy</Link> </label>
                        </div>
                        {/* <button type='submit' className={styles.ghost}>Sign Up</button> */}
                        <button type='submit' className={styles.ghost}>Verify Email</button>
                    </div>
                </form>
            )
        else {
            return (
                <div>
                    <h1>Problem Loading page</h1>
                </div>
            )
        }
    }

    //MARK:Loginnew render
    return (
        <div className={styles.outer}>
            <div className={styles.logodiv}>
                <img src={process.env.PUBLIC_URL + "/images/white-logo.png"} alt='editlatex_logo' />
            </div>

            <div className={`${styles.container} ${active ? styles.rightPanelActive : ""}`} id="container">
                <div className={`${styles.formContainer} ${styles.signUpContainer}`}>
                    {renderScreen()}
                </div>
                <div className={`${styles.formContainer} ${styles.signInContainer}`}>
                    {renderScreen()}
                </div>
                <div className={styles.overlayContainer}>
                    <div className={styles.overlay}>
                        <div className={`${styles.overlayPanel} ${styles.overlayLeft}`}>
                            <h1 className={styles.heading}>Welcome Back!</h1>
                            <p className={styles.para}>Please enter your details to continue</p>
                            <Link to={"/loginnew/signIn"} onClick={() => setActive(false)} className={styles.ghost} id="signIn">Sign In</Link>
                        </div>
                        <div className={`${styles.overlayPanel} ${styles.overlayRight}`}>
                            <h1 className={styles.heading}>Create Your Account</h1>
                            <p className={styles.para}>Enter your personal details to get started.</p>

                            <Link to={"/loginnew/signUp"} onClick={() => setActive(true)} className={styles.ghost} id="signUp">Sign Up</Link>
                        </div>
                    </div>
                </div>
            </div >
        </div>

    )
}

export default Loginnew